/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_OauthInputs */

const en_login_error_oauth = /** @type {(inputs: Login_Error_OauthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign-in failed. Please try again or use a different method.`)
};

const ar_login_error_oauth = /** @type {(inputs: Login_Error_OauthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فشل تسجيل الدخول. يُرجى المحاولة مرة أخرى أو استخدام طريقة أخرى.`)
};

/**
* | output |
* | --- |
* | "Sign-in failed. Please try again or use a different method." |
*
* @param {Login_Error_OauthInputs} inputs
* @param {{ locale?: "en" | "ar" }} options
* @returns {LocalizedString}
*/
export const login_error_oauth = /** @type {((inputs?: Login_Error_OauthInputs, options?: { locale?: "en" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_OauthInputs, { locale?: "en" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_login_error_oauth(inputs)
	return ar_login_error_oauth(inputs)
});